// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReconciliationTwoToneSvg from "@ant-design/icons-svg/es/asn/ReconciliationTwoTone";
import AntdIcon from '../components/AntdIcon';

var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationTwoToneSvg
  }));
};

ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
export default React.forwardRef(ReconciliationTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ReconciliationTwoTone.js
// module id = 1681
// module chunks = 0